<template>
  <v-card>
    <v-card-text>
      <v-row
          v-if="!isAdmin"
          class="text-center">
        <v-col>
          <v-alert
              outlined
              :value="accessDateIsExpired"
              type="warning">
            {{ $t('Для получения доступа к участию в торгах/созданию запросов по торговым процедурам необходимо оплатить договор.') }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row
          v-if="contract &&
            !contract.contractNumber &&
            !loading"
          class="text-center">
        <v-col cols="12">
          {{ $t('Сведения о договоре не добавлены') }}
          <btn-icon-tip
              v-if="isAdmin"
              id="addBtn"
              icon="add"
              icon-color="primary"
              btn-color="primary"
              :tip="$t('Добавить договор')"
              @click="showContractDialog" />
        </v-col>
      </v-row>
      <v-row v-if="contract && contract.contractNumber">
        <v-col cols="8">
          <text-view
              :label="$t('Номер договора')"
              flex-size="xs12"
              :display="contract.contractNumber" />
          <date-view
              :label="$t('Дата договора')"
              flex-size="xs12"
              :display="contract.contractDate" />
          <date-view
              :label="$t('Дата оплаты договора')"
              flex-size="xs12"
              :display="contract.paymentDate" />
        </v-col>
        <v-col
            v-if="isAdmin"
            cols="4"
            align-self="start"
            class="text-rigth">
          <btn-icon-tip
              id="editContract"
              icon="edit"
              icon-color="primary"
              :tip="$t('Редактировать договор')"
              @click="showContractDialog" />
          <btn-icon-tip
              id="editPaymentDate"
              icon="today"
              icon-color="primary"
              :tip="$t('Редактировать дату оплаты договора')"
              @click="showContractPaymentDateDialog" />
          <btn-icon-tip
              id="sendNotification"
              icon="notification_important"
              icon-color="primary"
              :tip="$t('Отправить повторное уведомление о регистрации')"
              @click="showNotificationDialog" />
          <notification-of-organization-acceptance-dialog
              v-if="notificationDialog.show"
              :dialog-prop="notificationDialog"
              @close="closeDialog('notificationDialog')" />
          <contract-payment-date-dialog
              v-if="contractPaymentDateDialog.show"
              :dialog-prop="contractPaymentDateDialog"
              @close="closeDialog('contractPaymentDateDialog')" />
        </v-col>
      </v-row>
      <contract-dialog
          v-if="contractDialog.show"
          :dialog-prop="contractDialog"
          @close="closeDialog('contractDialog')" />
    </v-card-text>
  </v-card>
</template>

<script>
  import DateView from '@/components/reused/ui/DateView.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ContractPaymentDateDialog from './ContractPaymentDateDialog.vue'
  import ContractDialog from './ContractDialog.vue'
  import NotificationOfOrganizationAcceptanceDialog from './NotificationOfOrganizationAcceptanceDialog.vue'

  export default {
    components: {
      DateView,
      TextView,
      BtnIconTip,
      ContractPaymentDateDialog,
      ContractDialog,
      NotificationOfOrganizationAcceptanceDialog
    },
    props: {
      contract: {
        type: Object,
        default: function () {
          return { }
        }
      },
      edited: {
        type: [Function, Promise]
      },
      loading: {
        type: Boolean
      },
      organizationId: {
        type: String
      }
    },
    data () {
      return {
        notificationDialog: {
          show: false,
          organizationId: null
        },
        contractPaymentDateDialog: {
          show: false,
          organizationId: null,
          date: null,
          callback: this.edited
        },
        contractDialog: {
          show: false,
          organizationId: null,
          contractInfo: {},
          callback: this.edited
        }
      }
    },
    computed: {
      accessDateIsExpired () {
        if (this.isAdmin) {
          return false
        }

        const paymentDate = this.contract.paymentDate
        if (!paymentDate) {
          return true
        }
        const accessDate = this.$moment(paymentDate).add(1, 'years')
        const now = this.$moment()
        return now.isAfter(accessDate)
      }
    },
    methods: {
      // открыть окно создания/редактирования договора
      showContractDialog: function () {
        this.contractDialog.contractInfo = this.contract
        this.contractDialog.organizationId = this.organizationId
        this.contractDialog.callback = this.edited
        this.contractDialog.show = true
      },
      // открыть окно редактирования даты платежа по договору
      showContractPaymentDateDialog: function () {
        this.contractPaymentDateDialog.organizationId = this.organizationId
        this.contractPaymentDateDialog.date = this.contract.paymentDate
        this.contractPaymentDateDialog.callback = this.edited
        this.contractPaymentDateDialog.show = true
      },
      showNotificationDialog: function () {
        this.notificationDialog.organizationId = this.organizationId
        this.notificationDialog.show = true
      }
    }
  }
</script>
